import { Department } from "@/interfaces/department";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCompanyDepartmentStore = defineStore(
  "companyDepartments",
  () => {
    const departments = ref<Department[]>([]);
    const companyId = ref<number | null>(null);

    return {
      departments,
      companyId,

      setDepartments(value: Department[]) {
        departments.value = value;
      },

      setCompanyId(value: number | null) {
        companyId.value = value;
      },
    };
  },
);
